(function () {
  function parseMs(value, fallback) {
    var n = parseInt(value, 10);
    return !isNaN(n) && n > 0 ? n : fallback;
  }

  function initHeroUsp(root) {
    if (!root) return;
    if (root._heroSlideTimer) {
      clearInterval(root._heroSlideTimer);
      root._heroSlideTimer = null;
    }
    if (root._heroUspTimer) {
      clearInterval(root._heroUspTimer);
      root._heroUspTimer = null;
    }
    root.setAttribute('data-hero-usp-init', '1');

    var slides = root.querySelectorAll('[data-hero-usp-slide]');
    var slideCount = slides.length;
    var autoplay = parseMs(root.getAttribute('data-slideshow-interval'), 0);
    var current = 0;
    var slideTimer;

    function goSlide(i) {
      if (slideCount < 1) return;
      current = ((i % slideCount) + slideCount) % slideCount;
      slides.forEach(function (el, idx) {
        var active = idx === current;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      root.querySelectorAll('[data-hero-usp-dot]').forEach(function (dot, idx) {
        var on = idx === current;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    if (slideCount > 1 && autoplay > 0) {
      slideTimer = setInterval(function () {
        goSlide(current + 1);
      }, autoplay);
      root._heroSlideTimer = slideTimer;
    }

    root.querySelectorAll('[data-hero-usp-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-hero-usp-dot'), 10);
        if (!isNaN(idx)) goSlide(idx);
      });
    });

    var uspRotate = parseMs(root.getAttribute('data-usp-rotate-interval'), 5000);
    var track = root.querySelector('[data-hero-usp-usp-mobile-track]');
    var uspItems = root.querySelectorAll('[data-hero-usp-usp-item]');
    var uspIndex = 0;
    var uspTimer;
    var mq = window.matchMedia('(max-width: 767px)');

    function stepUsp() {
      if (!track || uspItems.length < 2) return;
      uspIndex = (uspIndex + 1) % uspItems.length;
      track.style.transform = 'translateX(-' + uspIndex * 100 + '%)';
    }

    function bindUsp() {
      if (uspTimer) {
        clearInterval(uspTimer);
        uspTimer = null;
      }
      if (mq.matches && track && uspItems.length > 1) {
        track.style.transform = 'translateX(0)';
        uspIndex = 0;
        uspTimer = setInterval(stepUsp, uspRotate);
        root._heroUspTimer = uspTimer;
      } else if (track) {
        track.style.transform = 'translateX(0)';
        uspIndex = 0;
      }
    }

    bindUsp();
    if (mq.addEventListener) {
      mq.addEventListener('change', bindUsp);
    } else if (mq.addListener) {
      mq.addListener(bindUsp);
    }

  }

  function boot() {
    document.querySelectorAll('[data-hero-usp]').forEach(initHeroUsp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target.querySelector('[data-hero-usp]');
    if (root) initHeroUsp(root);
  });
})();
